export class FolderListRefreshEvent {
	public constructor() {}
}
